import { Text, TextProps, Tooltip } from '@mantine/core';
import React from 'react';

interface UnderlineTooltipProps {
  label: string;
  children: React.ReactNode;
  size?: TextProps['size'];
  fw?: TextProps['fw'];
  c?: TextProps['c'];
}

export function UnderlineTooltip({
  label,
  children,
  size = 'md',
  fw = 600,
  c = 'gray.10',
}: UnderlineTooltipProps) {
  return (
    <Tooltip label={label}>
      <Text
        fw={fw}
        size={size}
        c={c}
        style={{
          borderBottom: '1px dotted var(--mantine-color-gray-10)',
          display: 'inline-block',
        }}
      >
        {children}
      </Text>
    </Tooltip>
  );
}
